import * as types from '../mutation-types'
const state = {
	about: []
}

const actions = {
	fetchAbout ({ commit }) {
		return window.axios.get('/aboutus').then((response) => {
			commit(types.STORE_ABOUT, response.data)
			return response.data
		})
	}
}

const mutations = {
	[types.STORE_ABOUT] (state, about) {
		state.about = about;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}